import { useState, useCallback } from 'react';
import axios from '../../config/axiosInstance';
import { message } from 'antd';

const useControlListData = () => {
    const [participants, setParticipants] = useState([]);
    const [checkedIds, setCheckedIds] = useState([]);
    const [deviceConfigs, setDeviceConfigs] = useState([]);

    const fetchDeviceConfigs = useCallback(async () => {
        try {
            const response = await axios.get('/deviceConfigs');
            setDeviceConfigs(response.data);
        } catch (error) {
            console.error('Error fetching deviceConfigs:', error);
            message.error('Error loading deviceConfigs');
        }
    }, []);

    const fetchParticipantsAndLeads = useCallback(async (eventId, programmePointId, host) => {
        if (!eventId) {
            message.warning("⚠️ No event selected. Please select a configuration with an event.");
            return;
        }

        if (!programmePointId) {
            message.warning("⚠️ No programme point selected. Please select a configuration with a programme point.");
            return;
        }

        try {
            const token = await fetchToken(host);

            const allBody = { eventPK: eventId };
            const allRes = await axios.post(`/regasus/participants/search?host=${host}&token=${encodeURIComponent(token)}`, allBody);
            const allRaw = allRes.data?.participantInfos?.participantInfo || [];
            const allFiltered = allRaw.filter(p => p.participantStateId !== 3 && p.participantStateId !== 4);

            const allFormatted = allFiltered.map((p, index) => ({
                key: p.id || index,
                vigenereCode: p.vigenereCode || '',
                firstName: p.firstName || '',
                lastName: p.lastName || '',
                email: p.email || '',
                organisation: p.organisation || '',
                participantStateId: p.participantStateId,
            }));

            setParticipants(allFormatted);

            const hasLeadBody = {
                eventPK: eventId,
                hasLead: programmePointId ? [programmePointId] : undefined,
            };

            const hasLeadRes = await axios.post(`/regasus/participants/search?host=${host}&token=${encodeURIComponent(token)}`, hasLeadBody);
            const hasLeadRaw = hasLeadRes.data?.participantInfos?.participantInfo || [];
            const hasLeadCodes = hasLeadRaw.map(p => p.vigenereCode).filter(Boolean);

            setCheckedIds(hasLeadCodes);
        } catch (err) {
            console.error(err);
            message.error('Error fetching participants and leads');
        }
    }, []);

    const fetchParticipantDetails = useCallback(async ({ host, participantId }) => {
        try {
            const token = await fetchToken(host);
            const res = await axios.post('/regasus/get-participant-by-id', {
                token,
                host,
                participantId
            });
            return res.data;
        } catch (error) {
            console.error('Error fetching participant details:', error);
            message.error('Error loading participant details');
            return null;
        }
    }, []);

    const fetchToken = async (host) => {
        try {
            const res = await axios.get(`/regasus/token?host=${host}`);
            const token = res.data?.access_token;

            if (!token) {
                console.warn('⚠️ Token is missing in the response');
                return null;
            }

            return token;
        } catch (err) {
            console.error('❌ Error fetching token:', err.message);
            return null;
        }
    };

    return {
        participants,
        checkedIds,
        deviceConfigs,
        setCheckedIds,
        fetchParticipantsAndLeads,
        fetchDeviceConfigs,
        fetchParticipantDetails,
    };
};

export default useControlListData;